import * as React from "react";
import { SVGProps } from "react";

const TimeZone = (props: SVGProps<SVGSVGElement>) => (
<svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <g fill="#1C1C1C" clipPath="url(#clip0_604_1346)">
      <path d="M10 19.375A9.375 9.375 0 1 1 19.375 10a.624.624 0 1 1-1.25 0A8.125 8.125 0 1 0 10 18.125a.625.625 0 0 1 0 1.25"></path>
      <path d="M17.188 6.25H2.813a.625.625 0 0 1 0-1.25h14.375a.625.625 0 1 1 0 1.25M10 10.625H1.25a.625.625 0 1 1 0-1.25H10a.625.625 0 1 1 0 1.25M8.125 15H2.813a.625.625 0 1 1 0-1.25h5.312a.625.625 0 1 1 0 1.25"></path>
      <path d="M10 19.375c-2.628 0-4.687-4.118-4.687-9.375S7.372.625 10 .625c2.26 0 4.147 3.058 4.59 7.438a.625.625 0 1 1-1.243.124C12.983 4.59 11.543 1.875 10 1.875c-1.625 0-3.437 3.337-3.437 8.125S8.375 18.125 10 18.125a.624.624 0 1 1 0 1.25"></path>
      <path d="M14.375 19.375a5 5 0 1 1 0-10 5 5 0 0 1 0 10m0-8.75a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5"></path>
      <path d="M13.438 15.938a.625.625 0 0 1-.442-1.067l.754-.755v-2.241a.625.625 0 0 1 1.25 0v2.5a.63.63 0 0 1-.183.442l-.937.937a.63.63 0 0 1-.442.184"></path>
    </g>
    <defs>
      <clipPath id="clip0_604_1346">
        <path fill="#fff" d="M0 0h20v20H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default TimeZone;
